<div class="auth0-callback">
  <div *ngIf="loading" class="screen-overlay-message auth0-callback-loading">
    <div class="auth0-callback-loading-content">
      <span class="loading-animation align-center"></span>
      <p>Signing you in...</p>
    </div>
  </div>
  <app-confirm-modal></app-confirm-modal>
</div>
